import axios from "axios";
import { sendEmailEndpoint } from "../apiRequests/endpoints";

export const sendEmail = async (to, subject, htmlContent, textContent = null) => {
  try {
    const emailData = {
      to: [
        {
          email: to,
          name: "Sistema",
        },
      ],
      subject: subject,
      htmlContent: htmlContent,
      textContent: textContent,
    };

    const response = await axios.post(
      sendEmailEndpoint,
      emailData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    
    if (!response.data.success) {
      throw new Error(response.data.error || "Error desconocido al enviar el email");
    }
    
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.error || error.message;
    throw new Error("Error al enviar el email (emailSender.js): " + errorMessage);
  }
};

export const sendErrorNotification = async (error, context) => {
  const subject = "Error en el sistema - Support TI";
  const htmlContent = `
    <html>
      <body>
        <h2 style="color: #d32f2f;">🚨 Error detectado!</h2>
        <div style="background-color: #f5f5f5; padding: 20px; border-radius: 8px; margin: 20px 0;">
          <h3>📋 Detalles del Error</h3>
          <p><strong>Contexto:</strong> ${context}</p>
          <p><strong>Error:</strong> ${error.message}</p>
          <p><strong>Fecha:</strong> ${new Date().toLocaleString('es-AR')}</p>
          <p><strong>Hora:</strong> ${new Date().toLocaleTimeString('es-AR')}</p>
        </div>
        
        <div style="background-color: #fff3cd; padding: 15px; border-radius: 8px; margin: 20px 0;">
          <h3>🔍 Stack Trace</h3>
          <pre style="background-color: #f8f9fa; padding: 10px; border-radius: 4px; overflow-x: auto; font-size: 12px;">${error.stack || 'No disponible'}</pre>
        </div>
        
        <div style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #ddd;">
          <p style="color: #666; font-size: 12px;">
            Este email fue generado automáticamente por el sistema de notificaciones de Support TI.
          </p>
        </div>
      </body>
    </html>
  `;
  
  return sendEmail("sistema@support-ti.com", subject, htmlContent);
}; 